import { Placeholder } from '@lmn/design-system';
import styled from 'styled-components';
import React from 'react';
import customCss from '@/app/components/hotel-detail/css/customCss';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

// Mirrors EvoRoomCard: full-bleed image on top (mobile, flex column) → 200px side image (desktop, CSS grid).
const SkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  border-radius: ${({ theme }) => theme.kallisto.border.radius.radius200};

  @media ${customCss.breakpoints.sm} {
    display: grid;
    grid-template-columns: 200px 1fr;
    column-gap: ${({ theme }) => theme.kallisto.space.space300};
    align-items: start;
    padding: ${({ theme }) => theme.kallisto.space.space300};
    overflow: visible;
  }
`;

// Full-bleed image on top of the mobile card; hidden on desktop.
const MobileImage = styled.div`
  width: 100%;
  height: 160px;

  @media ${customCss.breakpoints.sm} {
    display: none;
  }
`;

// 200x200 side image on desktop; hidden on mobile.
const DesktopImage = styled.div`
  display: none;

  @media ${customCss.breakpoints.sm} {
    display: block;
  }
`;

// Padded content column on mobile; hidden on desktop.
const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.kallisto.space.space200};
  padding: ${({ theme }) =>
    `${theme.kallisto.space.space150} ${theme.kallisto.space.space200} ${theme.kallisto.space.space200}`};

  @media ${customCss.breakpoints.sm} {
    display: none;
  }
`;

// Content column beside the image on desktop; hidden on mobile.
const DesktopContent = styled.div`
  display: none;

  @media ${customCss.breakpoints.sm} {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.kallisto.space.space200};
  }
`;

export function EvoRoomSkeletons() {
  return (
    <ContentContainer>
      {[1, 2, 3].map((item) => (
        <RoomSkeletonCard key={item} />
      ))}
    </ContentContainer>
  );
}

function RoomSkeletonCard() {
  return (
    <SkeletonCard>
      <MobileImage>
        <Placeholder width="100%" height="100%" />
      </MobileImage>
      <DesktopImage>
        <Placeholder width="200px" height="200px" borderRadius="radius100" />
      </DesktopImage>

      <MobileContent>
        <Placeholder height="20px" width="70%" />
        <Placeholder height="20px" width="50%" />
        <Placeholder height="20px" width="100%" />
        <Placeholder height="20px" width="100%" />
        <Placeholder height="20px" width="100%" />
      </MobileContent>

      <DesktopContent>
        <Placeholder height="24px" width="45%" />
        <Placeholder height="20px" width="88%" />
        <Placeholder height="20px" width="88%" />
      </DesktopContent>
    </SkeletonCard>
  );
}
